module.exports = __webpack_public_path__ + "static/media/project_identidade_visual.bda4e275.jpg";